import React from 'react';
import PropTypes from 'prop-types';
import Interstitial from './index';

const ReplaceCardModal = ({ trigger, isHCP }) => {
  const content = (<React.Fragment>
    {!isHCP
      ? (
        <p className="patient-text">For help replacing your card, please&nbsp;call: </p>
      )
      : (<p className="hcp-text">For assistance replacing your patient’s&nbsp;card, please call: </p>)}
    <div className="d-flex">
      <img src="/images/phone.svg" alt="phone-icon"></img>
      <p>
        <strong className="poppins-bold">Takeda Oncology Here2Assist<br />
        1-844-817-6468, Option 2.</strong><br />
        Monday-Friday, 8AM-8PM ET.
      </p>
    </div>
  </React.Fragment>);

  return (
    <Interstitial
      main_content={ content }
      class={ `replace-card-modal${isHCP ? ' hcp-modal' : ''}` }
      trigger={ trigger }
    />
  );
};

ReplaceCardModal.propTypes = {
  isHCP: PropTypes.bool,
};

export default ReplaceCardModal;
